// // src/components/HelpfaqMobile.jsx
// import { useContext, useEffect, useState } from "react";
// import { collection, doc, getDoc, onSnapshot } from "firebase/firestore";
// import { db } from "../firebase";
// import { useAuth } from "../context/AuthContext";
// import { LanguageContext } from "../context/LanguageContext";
// import MobileDrawer from "./menus/MobileDrawer";
// import {
//   Box,
//   Typography,
//   IconButton,
//   Badge,
//   Menu,
//   MenuItem,
//   ListItemText,
//   Container,
//   Grid,
//   Paper,
// } from "@mui/material";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import MobileHeader from "./headers/MobileHearder";

// export default function HelpfaqMobile() {
//   const { translate } = useContext(LanguageContext);
//   const { currentUser, logOut } = useAuth();
//   const [role, setRole] = useState("Normal User");
//   const [anchorNotif, setAnchorNotif] = useState(null);
//   const [anchorProfile, setAnchorProfile] = useState(null);
//   const [notifications, setNotifications] = useState([]);
//   const unreadCount = notifications.filter((n) => !n.read).length;

//   useEffect(() => {
//     if (!currentUser) return;
//     getDoc(doc(db, "profilsUsers", currentUser.uid)).then((snap) => {
//       if (snap.exists()) setRole(snap.data().role || "Normal User");
//     });
//   }, [currentUser]);

//   // notifications
//   useEffect(() => {
//     if (!currentUser) return;
//     const col = collection(
//       db,
//       "profilsUsers",
//       currentUser.uid,
//       "notifications"
//     );
//     return onSnapshot(col, (snap) =>
//       setNotifications(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
//     );
//   }, [currentUser]);

//   const handleBellClick = (e) => setAnchorNotif(e.currentTarget);
//   const handleBellClose = () => setAnchorNotif(null);
//   const handleProfileClick = (e) => setAnchorProfile(e.currentTarget);
//   const handleProfileClose = () => setAnchorProfile(null);

//   return (
//     <Box sx={{ minHeight: "100vh", bgcolor: "#f4f8f9" }}>
//       {/* <Box
//         sx={{ display: "flex", alignItems: "center", p: 1, bgcolor: "white" }}
//       > */}
//       <Box
//         sx={{
//           position: "sticky",
//           top: 0,
//           zIndex: 1100, // ou theme.zIndex.appBar
//           display: "flex",
//           alignItems: "center",
//           p: 1,
//           bgcolor: "white",
//         }}
//       >

//         <MobileHeader
//           title={translate("AboutHeroTitle")}
//           showProfileItem={false}
//           showGoPremium={false}
//         />
//       </Box>

//       <Menu
//         anchorEl={anchorNotif}
//         open={Boolean(anchorNotif)}
//         onClose={handleBellClose}
//       >
//         {notifications.length === 0 ? (
//           <MenuItem disabled>
//             <ListItemText primary={translate("NoNotifications")} />
//           </MenuItem>
//         ) : (
//           notifications.map((n) => (
//             <MenuItem key={n.id} onClick={handleBellClose}>
//               <ListItemText
//                 primary={n.message}
//                 secondary={new Date(
//                   n.timestamp.seconds * 1000
//                 ).toLocaleString()}
//               />
//             </MenuItem>
//           ))
//         )}
//       </Menu>

//       <Menu
//         anchorEl={anchorProfile}
//         open={Boolean(anchorProfile)}
//         onClose={handleProfileClose}
//       >
//         <MenuItem
//           onClick={() => {
//             handleProfileClose();
//             logOut();
//           }}
//         >
//           <ListItemText primary={translate("Logout")} />
//         </MenuItem>
//       </Menu>

//       <Box
//         sx={{
//           p: 2,
//           display: "flex",
//           flexDirection: "column",
//           gap: 4,
//           overflowY: "auto",
//         }}
//       >
//         <Container>
//           <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
//             {translate("AboutHeroTitle")}
//           </Typography>
//           <Typography variant="body1" color="text.secondary" align="center">
//             {translate("AboutHeroSubtitle")}
//           </Typography>
//         </Container>

//         <Container>
//           <Typography variant="h5" fontWeight={600} align="center" gutterBottom>
//             {translate("AboutModelTitle")}
//           </Typography>
//           <Grid container spacing={2} justifyContent="center">
//             {["FreePlan", "PremiumPlan"].map((plan, i) => (
//               <Grid key={i} item xs={12} sm={6}>
//                 <Paper sx={{ p: 2, borderRadius: 2 }}>
//                   <Typography variant="h6" fontWeight={600}>
//                     {translate(`${plan}Title`)}
//                   </Typography>
//                   {[1, 2].map((j) => (
//                     <Typography key={j}>
//                       • {translate(`${plan}Feature${j}`)}
//                     </Typography>
//                   ))}
//                   {plan === "PremiumPlan" && (
//                     <Typography>
//                       • {translate("PremiumPlanFeature3")}
//                     </Typography>
//                   )}
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>

//         <Container>
//           <Typography variant="h5" fontWeight={600} align="center" gutterBottom>
//             {translate("WhyChooseTitle")}
//           </Typography>
//           <Grid container spacing={2} justifyContent="center">
//             {[1, 2, 3].map((i) => (
//               <Grid key={i} item xs={12} sm={4}>
//                 <Paper sx={{ p: 2, textAlign: "center", borderRadius: 2 }}>
//                   <Typography variant="subtitle1" fontWeight={600} gutterBottom>
//                     {translate(`WhyChooseFeature${i}Title`)}
//                   </Typography>
//                   <Typography color="text.secondary">
//                     {translate(`WhyChooseFeature${i}Desc`)}
//                   </Typography>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>
//     </Box>
//   );
// }

import { useContext, useEffect, useState } from "react";
import { collection, doc, onSnapshot, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import { LanguageContext } from "../context/LanguageContext";
import {
  Box,
  Typography,
  Menu,
  MenuItem,
  ListItemText,
  Container,
  Grid,
  Paper,
  TextField,
  Button,
  LinearProgress,
  Alert,
} from "@mui/material";
import MobileHeader from "./headers/MobileHearder";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { getFunctions, httpsCallable } from "firebase/functions";

export default function HelpfaqMobile() {
  const { translate } = useContext(LanguageContext);
  const { currentUser, logOut } = useAuth();
  const [role, setRole] = useState("Normal User");
  const [notifications, setNotifications] = useState([]);
  const [anchorNotif, setAnchorNotif] = useState(null);
  const [anchorProfile, setAnchorProfile] = useState(null);
  const [darkMode, setDarkMode] = useState(false);
  const [ttsInput, setTtsInput] = useState("");
  const [ttsLoading, setTtsLoading] = useState(false);
  const [ttsError, setTtsError] = useState("");
  const [audioUrl, setAudioUrl] = useState("");
  const [ttsVoice, setTtsVoice] = useState("alloy");
  const [ttsLang, setTtsLang] = useState("fr");
  const functions = getFunctions();
  const enableTts = false; // feature temporairement désactivée

  const lightTheme = createTheme({
    palette: {
      mode: "light",
      background: { default: "#f4f8f9", paper: "#fff" },
    },
  });
  const darkTheme = createTheme({
    palette: {
      mode: "dark",
      background: { default: "#121212", paper: "#1e1e1e" },
      text: { primary: "#fff", secondary: "#ccc" },
    },
  });

  useEffect(() => {
    if (!currentUser) return;
    const prefRef = doc(db, "profilsUsers", currentUser.uid);
    const unsub = onSnapshot(prefRef, (snap) => {
      if (!snap.exists()) return;
      const data = snap.data();
      setRole(data.role || "Normal User");
      if (data.darkMode !== undefined) setDarkMode(data.darkMode);
    });
    // petit fetch initial (optionnel)
    getDoc(prefRef).then((docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setRole(data.role || "Normal User");
        if (data.darkMode !== undefined) setDarkMode(data.darkMode);
      }
    });
    return () => unsub();
  }, [currentUser]);

  // notifications
  useEffect(() => {
    if (!currentUser) return;
    const col = collection(
      db,
      "profilsUsers",
      currentUser.uid,
      "notifications"
    );
    return onSnapshot(col, (snap) =>
      setNotifications(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, [currentUser]);

  const handleBellClick = (e) => setAnchorNotif(e.currentTarget);
  const handleBellClose = () => setAnchorNotif(null);
  const handleProfileClick = (e) => setAnchorProfile(e.currentTarget);
  const handleProfileClose = () => setAnchorProfile(null);
  useEffect(() => {
    return () => {
      if (audioUrl) URL.revokeObjectURL(audioUrl);
    };
  }, [audioUrl]);

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "background.default",
          color: "text.primary",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1100,
            display: "flex",
            alignItems: "center",
            p: 1,
            bgcolor: "background.paper", // pas "white", respecte le thème
          }}
        >
          <MobileHeader
            title={translate("AboutHeroTitle")}
            showProfileItem={false}
            showGoPremium={false}
          />
        </Box>

        {/* Menus */}
        <Menu
          anchorEl={anchorNotif}
          open={Boolean(anchorNotif)}
          onClose={handleBellClose}
        >
          {notifications.length === 0 ? (
            <MenuItem disabled>
              <ListItemText primary={translate("NoNotifications")} />
            </MenuItem>
          ) : (
            notifications.map((n) => (
              <MenuItem key={n.id} onClick={handleBellClose}>
                <ListItemText
                  primary={n.message}
                  secondary={
                    n.timestamp
                      ? new Date(n.timestamp.seconds * 1000).toLocaleString()
                      : ""
                  }
                />
              </MenuItem>
            ))
          )}
        </Menu>

        <Menu
          anchorEl={anchorProfile}
          open={Boolean(anchorProfile)}
          onClose={handleProfileClose}
        >
          <MenuItem
            onClick={() => {
              handleProfileClose();
              logOut();
            }}
          >
            <ListItemText primary={translate("Logout")} />
          </MenuItem>
        </Menu>

        {/* Contenu */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 4,
            overflowY: "auto",
            bgcolor: "background.default",
          }}
        >
          <Container>
            <Typography
              variant="h4"
              fontWeight={700}
              align="center"
              gutterBottom
            >
              {translate("AboutHeroTitle")}
            </Typography>
            <Typography variant="body1" color="text.secondary" align="center">
              {translate("AboutHeroSubtitle")}
            </Typography>
          </Container>

          <Container>
            <Typography
              variant="h5"
              fontWeight={600}
              align="center"
              gutterBottom
            >
              {translate("AboutModelTitle")}
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              {["FreePlan", "PremiumPlan"].map((plan, i) => (
                <Grid key={i} item xs={12} sm={6}>
                  <Paper
                    sx={{ p: 2, borderRadius: 2, bgcolor: "background.paper" }}
                  >
                    <Typography variant="h6" fontWeight={600}>
                      {translate(`${plan}Title`)}
                    </Typography>
                    {[1, 2].map((j) => (
                      <Typography key={j}>
                        • {translate(`${plan}Feature${j}`)}
                      </Typography>
                    ))}
                    {plan === "PremiumPlan" && (
                      <Typography>
                        • {translate("PremiumPlanFeature3")}
                      </Typography>
                    )}
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>

          <Container>
            <Typography
              variant="h5"
              fontWeight={600}
              align="center"
              gutterBottom
            >
              {translate("WhyChooseTitle")}
            </Typography>
            <Grid container spacing={2} justifyContent="center">
              {[1, 2, 3].map((i) => (
                <Grid key={i} item xs={12} sm={4}>
                  <Paper
                    sx={{
                      p: 2,
                      textAlign: "center",
                      borderRadius: 2,
                      bgcolor: "background.paper",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      gutterBottom
                    >
                      {translate(`WhyChooseFeature${i}Title`)}
                    </Typography>
                    <Typography color="text.secondary">
                      {translate(`WhyChooseFeature${i}Desc`)}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>

          {/* Génération audio OpenAI temporairement désactivée */}
          {enableTts && (
            <Container>
              <Typography
                variant="h5"
                fontWeight={600}
                align="center"
                gutterBottom
              >
                Générer un audio (FR)
              </Typography>
              <Paper
                sx={{
                  p: 2,
                  borderRadius: 2,
                  bgcolor: "background.paper",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <TextField
                  label="Texte à convertir"
                  multiline
                  minRows={3}
                  value={ttsInput}
                  onChange={(e) => setTtsInput(e.target.value)}
                  placeholder="Exemple : Bonjour, voici votre réponse en audio."
                />
                <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                  <TextField
                    select
                    size="small"
                    label="Voix"
                    value={ttsVoice}
                    onChange={(e) => setTtsVoice(e.target.value)}
                    sx={{ minWidth: 130 }}
                  >
                    {["alloy", "verse", "nova", "shimmer"].map((v) => (
                      <MenuItem key={v} value={v}>
                        {v}
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    select
                    size="small"
                    label="Langue"
                    value={ttsLang}
                    onChange={(e) => setTtsLang(e.target.value)}
                    sx={{ minWidth: 130 }}
                  >
                    {[
                      ["fr", "Français"],
                      ["en", "English"],
                      ["es", "Español"],
                      ["de", "Deutsch"],
                      ["it", "Italiano"],
                      ["pt", "Português"],
                      ["nl", "Nederlands"],
                    ].map(([code, label]) => (
                      <MenuItem key={code} value={code}>
                        {label}
                      </MenuItem>
                    ))}
                  </TextField>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={async () => {
                      const text = ttsInput.trim();
                      if (text.length < 3) {
                        setTtsError("Le texte est trop court.");
                        return;
                      }
                      setTtsError("");
                      setTtsLoading(true);
                      try {
                        const generate = httpsCallable(
                          functions,
                          "generateFaqAudio"
                        );
                        const res = await generate({
                          text,
                          voice: ttsVoice,
                          lang: ttsLang,
                        });
                        const { audio, contentType } = res.data || {};
                        if (!audio) throw new Error("Audio manquant");
                        const bytes = atob(audio);
                        const arr = new Uint8Array(bytes.length);
                        for (let i = 0; i < bytes.length; i++) {
                          arr[i] = bytes.charCodeAt(i);
                        }
                        const blob = new Blob([arr], {
                          type: contentType || "audio/mpeg",
                        });
                        if (audioUrl) URL.revokeObjectURL(audioUrl);
                        setAudioUrl(URL.createObjectURL(blob));
                      } catch (e) {
                        console.error(e);
                        setTtsError(
                          "Impossible de générer l'audio. Vérifiez la clé OpenAI côté fonctions."
                        );
                      } finally {
                        setTtsLoading(false);
                      }
                    }}
                    disabled={ttsLoading}
                  >
                    Générer
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    disabled={!audioUrl}
                    onClick={() => {
                      if (!audioUrl) return;
                      const a = document.createElement("a");
                      a.href = audioUrl;
                      a.download = "faq-audio.mp3";
                      a.click();
                    }}
                  >
                    Télécharger
                  </Button>
                </Box>
                {ttsLoading && <LinearProgress />}
                {ttsError && <Alert severity="error">{ttsError}</Alert>}
                {audioUrl && !ttsError && (
                  <audio controls src={audioUrl} style={{ width: "100%" }} />
                )}
              </Paper>
            </Container>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  );
}
